<template>
  <div class="surveillance-select-unit">
    <div class="panel" :class="`panel-${config.type}`">
      <div class="panel-heading">
        <div class="panel-title">
          <h4>
            <span class="label">
              {{ config.title }}
            </span>
          </h4>
        </div>
      </div>
      <div class="panel-body">
        <div v-if="units.length !== 0" class="select-unit row">
          <div v-for="(u, k) in units"
               :key="`${uid}-unit-${k}-${u.name}`">
            <div class="col-xs-6">
              <div :class="`unit-container label label-${config.type}`">
                <span class="unit-label text-left">
                  {{ u.name }}<br/>
                  <small>
                    {{ config.list.find(e => e.value.ufType === u.ufType).type.code }}
                  </small>
                </span>
                <btn class="close pull-right"
                     @click="remove(k)"
                     aria-label="Close">
                  <span aria-hidden="true">&times;
                  </span>
                </btn>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p v-html="config.empty">
          </p>
        </div>
      </div>
      <div class="panel-footer">
        <div class="form-group input-group input-group-sm">
          <span class="input-group-btn">
            <dropdown ref="dropdown" >
              <btn size="sm" class="dropdown-toggle"
                   :disabled="units.length > 0">
                {{ config.fieldLabel }} &nbsp;&nbsp;<span class="caret"></span>
              </btn>
              <template slot="dropdown">
                <li v-for="(f, k) in config.list"
                    :key="`select-unit-${k}`">
                  <a role="button"
                     @click="unit = f">
                    {{ f.label }}
                  </a>
                </li>
              </template>
            </dropdown>
          </span>
          <span class="form-control">
            {{ unit == null ? 'Aucun' : unit.label }}
          </span>
        </div>
        <btn :disabled="unit == null"
             type="default"
             size="sm"
             @click="add()">
          Ajouter
        </btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'surveillance-select-unit',

  props: {
    value: {
      type: Array,
      required: true
    },

    config: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      unit: null,
      units: this.value
    }
  },

  computed: {
    uid: function () {
      return 'select-unit-' + this._uid
    }
  },

  watch: {
    units: {
      handler () {
        this.$emit('input', this.units)
      },
      deep: true
    },

    value: function (value) {
      this.units = value
      this.unit = null
    }
  },

  methods: {
    add: function () {
      const { unit } = this
      this.units.push(unit.value)

      this.unit = null
    },

    remove: function (index) {
      const { units } = this
      units.splice(index, 1)

      this.unit = null
    }
  }
}
</script>

<style scoped lang="less">
.panel-title {
  padding-top: 0rem;
  padding-bottom: 0rem;
  .label {
    font-size: 100%;
  }
}

.panel-heading {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.input-group-addon {
  background-color: white;
}

.select-unit {
  .close {
    position: relative;
    top: 50%;
    padding: 0.3rem 0.7rem 0.5rem 0.72rem;
    font-size: 130%;
    color: white;
    opacity: 0.8;
    border-radius: 100%;

    &:hover {
      background-color: rgba(0, 0, 0, .2);
      opacity: 1;
    }
  }

  .unit-container {
    white-space: normal;
    display: inline-block;
    text-align: left;
    padding: 0.2rem;
    .unit-label {
      display: inline-block;
      max-width: 80%;
      word-break: break-all;
    }
  }

  .label {
    width: 100%;
    margin: 0.4rem 0rem;
    font-size: 100%;
    padding: 0.6rem;
    small {
      font-size: 65%;
    }
  }
}
</style>
